import { RouterManager } from '@aclass/admin/managers';
import { CustomerStory } from '@aclass/admin/storage/actions';
import { IAdminState, ICustomerModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class CustomerSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:customer-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<ICustomerModuleState['searchPageInitialized']>(['customerModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(CustomerSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(CustomerStory.dryRunSearchPage());
    }
}
